export { Uicons } from 'Pods/uicons/uicon';
